import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { memo, useState } from 'react';

import ItemShelf from '@/components/ItemShelf/ItemShelf';
import { RecommendationVisibilityWrapper } from '@/pages/Item/ItemPage/components/ItemPageCarousel/RecommendationVisibilityWrapper';
import { useAppSelector } from '@/redux/hooks';
import { getTrendingItems } from '@/redux/modules/home/home.selectors';
import { LotRecommendationType } from '@/utils/amplitude/analytics/item/trackLotRecommendationClicked.analytics';

type Props = {
    className?: string;
};

const TrendingItemsCarousel = ({ className }: Props) => {
    const { formatMessage } = useIntl();

    const itemIds = useAppSelector(getTrendingItems);
    const [visibleItemIds, setVisibleItemIds] = useState<number[]>([]);

    if (!itemIds.length) {
        return null;
    }

    return (
        <RecommendationVisibilityWrapper
            recommendationIds={visibleItemIds}
            recommendationType={LotRecommendationType.TrendingItems}
        >
            <ItemShelf
                className={className}
                identifier="trendingItems"
                itemIds={itemIds}
                onVisibleItemIdsChange={setVisibleItemIds}
                testid="trendingItemsCarousel"
                title={formatMessage({ id: 'trending_items' })}
            />
        </RecommendationVisibilityWrapper>
    );
};

export default memo<Props>(TrendingItemsCarousel);
